module.exports = __webpack_public_path__ + "static/img/011.706c568.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/templates/sotet-konyha/sample-thumbnails/011.jpg
// module id = 868
// module chunks = 0